/* Game-local image-state acting. No storefront character runtime is changed. */
(function () {
  'use strict';
  if (window.InnermonOfficeActor) return;
  class OfficeActor {
    constructor(root) {
      this.root = root;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.image = null;
      this.images = new Map();
      this.definitions = JSON.parse(root.querySelector('[data-game-actors]').textContent);
      this.definition = null;
      this.frame = null;
      this.paused = false;
      this.disposed = false;
      this.sequence = 0;
      this.elapsed = 0;
      this.last = 0;
      this.tick = this.tick.bind(this);
      this.changed = () => { this.cancel(); if (this.button && !this.motion.matches) this.draw(0); this.syncVisibility(); };
      this.motion.addEventListener('change', this.changed);
    }
    async prepare() {
      if (this.motion.matches) return;
      await Promise.all(Object.entries(this.definitions).map(async ([key, definition]) => {
        if (this.images.has(key)) return;
        const img = new Image();
        img.src = definition.src;
        await img.decode();
        if (!img.naturalWidth || this.disposed) throw new Error('Actor unavailable');
        this.images.set(key, img);
      }));
    }
    attach(button, species) {
      this.clear();
      if (!this.images.has(species.key) || this.motion.matches) return;
      this.image = this.images.get(species.key);
      this.definition = this.definitions[species.key];
      this.button = button;
      this.canvas = button.querySelector('[data-window-actor]');
      this.context = this.canvas.getContext('2d');
      if (!this.context) { this.clear(); return; }
      this.elapsed = 0;
      this.sequence = 'enter';
      this.paused = false;
      this.syncVisibility();
      this.draw(0);
      this.queue();
    }
    syncVisibility() {
      if (!this.button) return;
      const active = !this.motion.matches && !!this.image;
      this.canvas.hidden = !active;
      this.button.toggleAttribute('data-actor-active', active);
      this.button.querySelector('[data-window-image]').hidden = active;
    }
    react(duration = 520) {
      if (!this.button || this.motion.matches) return;
      this.cancel();
      this.hitDuration = duration;
      this.elapsed = 0;
      this.sequence = 'hit';
      this.draw(0); // Contact pose changes on the same paint as the HTML score.
      this.queue();
    }
    queue() {
      if (this.frame !== null || this.paused || this.disposed || !this.sequence || this.motion.matches) return;
      this.last = performance.now();
      this.frame = requestAnimationFrame(this.tick);
    }
    tick(now) {
      this.frame = null;
      if (this.paused || this.disposed || !this.button || this.motion.matches) return;
      this.elapsed += Math.max(0, now - this.last);
      this.last = now;
      // Keep every authored hit phase; higher levels play the same motion faster.
      this.draw(this.sequence === 'hit' ? this.elapsed * 520 / this.hitDuration : this.elapsed);
      const duration = this.sequence === 'enter' ? 220 : this.hitDuration;
      if (this.elapsed < duration) this.frame = requestAnimationFrame(this.tick);
      else this.sequence = 0;
    }
    draw(ms) {
      if (!this.context || !this.image) return;
      // Atlas contract: cell 0 = approved rest; 1 = command; 2 = interrupted.
      // Remaining cells, when present, contain genuine source motion, not CSS acting.
      const canvas = this.canvas;
      const size = this.definition.cell;
      const columns = this.definition.columns;
      const motionFrames = this.definition.frames;
      const ctx = this.context;
      let index = 1, y = 0;
      if (this.sequence === 'enter') {
        index = this.definition.returnMaster && ms < 100 ? 0 : 1;
        // Spatial entrance, not substitute acting: real articulation is in atlas.
        // The desk lip clips this travel so the specimen emerges from a hole.
        y = 82 * Math.pow(1 - Math.min(ms / 220, 1), 3);
      } else if (this.sequence === 'hit') {
        index = ms < 60 ? 2 : motionFrames ? 3 + Math.min(motionFrames - 1, Math.floor((ms - 60) / 260 * motionFrames)) : 2;
        if (ms >= 320) {
          index = this.definition.returnMaster ? 0 : 2 + motionFrames;
          y = (this.definition.returnMaster ? 45 : 105) * Math.pow(Math.min((ms - 320) / 200, 1), 2);
        }
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.save();
      // Coordinates are authored in CSS-independent 384px cells. Display is small.
      ctx.translate(0, y / 100 * canvas.height);
      ctx.drawImage(this.image, index % columns * size, Math.floor(index / columns) * size, size, size, 0, 0, canvas.width, canvas.height);
      ctx.restore();
      canvas.dataset.actorState = this.sequence === 'hit' ? ms < 60 ? 'contact' : ms < 320 ? 'recoil' : 'settle' : ms < 100 ? 'rest' : 'command';
      this.root.dispatchEvent(new CustomEvent('innermon:actor-paint', { detail: { canvas: canvas } }));
    }
    pause() { this.paused = true; this.cancel(); }
    resume() { this.paused = false; this.queue(); }
    cancel() { if (this.frame !== null) cancelAnimationFrame(this.frame); this.frame = null; }
    clear() {
      this.cancel(); this.sequence = 0;
      if (this.button) {
        this.button.removeAttribute('data-actor-active');
        this.canvas.hidden = true;
        this.button.querySelector('[data-window-image]').hidden = false;
      }
      this.button = null; this.canvas = null; this.context = null; this.image = null; this.definition = null;
    }
    dispose() { this.disposed = true; this.clear(); this.images.clear(); this.motion.removeEventListener('change', this.changed); }
  }
  window.InnermonOfficeActor = OfficeActor;
})();
